export default "__VITE_ASSET__Bwd9mlZt__"